import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6b3042bb")

_pushScopeId("data-v-6b3042bb")
const _hoisted_1 = { class: "DraggableTable" }
const _hoisted_2 = { class: "drag-thead-tr" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")
  const _component_Draggable = _resolveComponent("Draggable")
  const _component_a_empty = _resolveComponent("a-empty")
  const _component_a_spin = _resolveComponent("a-spin")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, { spinning: _ctx.loading }, {
      default: _withId(() => [
        _createVNode("table", {
          class: ["drag-table", _ctx.bordered?"has-border-top-left":"no-border-top"],
          boolean: _ctx.bordered
        }, [
          _createVNode("thead", { style: _ctx.tHeadStyle }, [
            _createVNode("tr", _hoisted_2, [
              (_ctx.rowSelect)
                ? (_openBlock(), _createBlock("th", {
                    key: 0,
                    class: ["drag-th td checkbox", _ctx.bordered?"has-border-bottom-right":"no-border-bottom"]
                  }, [
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.isAllCheck,
                      "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isAllCheck = $event)),
                      onChange: _ctx.checkAll
                    }, null, 8, ["checked", "onChange"])
                  ], 2))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (item) => {
                return (_openBlock(), _createBlock("th", {
                  class: ["drag-th td", {ellipsis: item.ellipsis}, _ctx.bordered?"has-border-bottom-right":"no-border-bottom"],
                  key: item.key,
                  style: {"text-align": item.align || "left", "width": item.width || "auto", "flex": `${item.width ? "none" : 1}`}
                }, _toDisplayString(item.title), 7))
              }), 128))
            ])
          ], 4),
          (_ctx.dragData.length !== 0)
            ? (_openBlock(), _createBlock(_component_Draggable, {
                key: 0,
                modelValue: _ctx.dragData,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dragData = $event)),
                tag: "tbody",
                onEnd: _ctx.onDragEnd,
                "item-key": "uid"
              }, {
                item: _withId(({ element,index }) => [
                  (_openBlock(), _createBlock("tr", {
                    class: "drag-item tr cursor-move",
                    key: element.uid
                  }, [
                    (_ctx.rowSelect)
                      ? (_openBlock(), _createBlock("td", {
                          key: 0,
                          class: ["td checkbox", _ctx.bordered?"has-border-bottom-right":"no-border-bottom"]
                        }, [
                          _createVNode(_component_a_checkbox, {
                            checked: element.isChecked,
                            "onUpdate:checked": ($event: any) => (element.isChecked = $event),
                            onChange: ($event: any) => (_ctx.checkChange(element, index))
                          }, null, 8, ["checked", "onUpdate:checked", "onChange"])
                        ], 2))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                      return (_openBlock(), _createBlock("td", {
                        key: col.dataIndex,
                        class: ["td", {ellipsis: col.ellipsis}, _ctx.bordered?"has-border-bottom-right":"no-border-bottom"],
                        style: {"text-align": col.align || "left", "width": `${col.width} !important` || "auto", "flex": `${col.width ? "none" : 1}`},
                        title: col.slots ? "" : element[col.dataIndex]
                      }, [
                        (col.slots)
                          ? _renderSlot(_ctx.$slots, col.slots.customRender, {
                              key: 0,
                              record: element,
                              index: index
                            })
                          : (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(element[col.dataIndex]), 1))
                      ], 14, ["title"]))
                    }), 128))
                  ]))
                ]),
                _: 1
              }, 8, ["modelValue", "onEnd"]))
            : (_openBlock(), _createBlock("tbody", _hoisted_4, [
                _createVNode("tr", null, [
                  _createVNode("td", {
                    class: "border-right-bottom",
                    colspan: _ctx.columns.length + (_ctx.rowSelect ? 1 : 0)
                  }, [
                    _createVNode(_component_a_empty, { image: _ctx.simpleImage }, null, 8, ["image"])
                  ], 8, ["colspan"])
                ])
              ]))
        ], 10, ["boolean"])
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
})